import {
  attributeKeys,
  attributeRegistry,
} from '@shared/assessment-definition/dist/src/attributes';
import type { AttributeValues } from '@shared/assessment-definition/dist/src/attributes';

export function attributeSuffix(
  attributes: AttributeValues | undefined,
  translate: (token: string, fallback: string) => string,
): string {
  const labels = attributeKeys.flatMap((key) => {
    const value = attributes?.[key];
    if (!value) return [];
    const token = attributeRegistry[key].summaryTokens[value];
    const label = translate(token, value);
    return [label === token ? value : label];
  });
  return labels.length ? ` (${labels.join(', ')})` : '';
}
